import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.solidIcon.background.hover.primary(params);

export default primary;
